import { render, staticRenderFns } from "./NumberScrolling.vue?vue&type=template&id=47db4fd8"
import script from "./NumberScrolling.vue?vue&type=script&lang=js"
export * from "./NumberScrolling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports